module.exports = __webpack_public_path__ + "img/logo-nh.2c5f8946.webp";